import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import * as ticketingStates from 'store/updateTicketing';
import { accessNested, joinClasses, sortObjectByOrder } from 'utils/utils';
import { track } from 'utils/tracking';
import { smoothScrollTo } from 'utils/smoothScroll';
import pure from 'utils/pure';
import Screenings from 'components/shared/theaters/screenings';
import Ticketing from 'components/shared/theaters/ticketing/ticketing';
import HomeEnt from 'components/shared/theaters/homeEnt';
// import * as svg from 'components/shared/svgIcons/svgIcons';
import s from 'components/shared/theaters/theater.sss';


// TODO: Move this to ticketing files
const isTicketingEnabled = (theater, ticketing) => (
	theater.id === ticketing.theaterId &&
	theater.activeScreening &&
	ticketing.state !== ticketingStates.NOT_ACTIVE
);


export default @pure class Theater extends Component {

	///////////////////////
	//// LIFE CYCLE ///////
	///////////////////////

	constructor(props) {
		super();
		this.select = this.select.bind(this);
		this.closeTicketing = this.closeTicketing.bind(this);
		this.keyDown = this.keyDown.bind(this);
		this.active = props.active;

		const { theater } = props;
		const filterPass = theater.filterPass;
		this.state = {
			open: filterPass && theater.active,
			disable: !filterPass
		};

		this.openMap = this.openMap.bind(this);
	}

	componentDidMount() {
		if (!this.props.theater.firstBatch && this.props.theater.active) {
			this.active = true;
			this.scrollToThis();
		}
		if (this.state.open) {
			this.setContentHeight();
		}
	}

	componentWillReceiveProps(nextProps) {
		const { theater } = nextProps;
		const { open } = this.state;
		const filterPass = theater.filterPass;
		const newState = {
			open: filterPass && theater.active,
			disable: !filterPass
		};
		if (open && !newState.open) newState.removing = true;
		this.setState(newState);
	}

	componentDidUpdate() {
		if (!this.active && this.props.theater.active) {
			this.scrollToThis();
		}
		this.active = this.props.theater.active;
		if (this.state.open) {
			this.setContentHeight();
		}
		if (this.state.removing) {
			setTimeout(() => {
				this.setState({ removing: false });
			}, 500);
		}
	}


	///////////////////////
	//// FUNCTIONS ////////
	///////////////////////

	scrollToThis() {
		if (!this.$el || this.props.preventScrollToTheater) return;
		// Margin from top/bottom on smoothScroll
		const header = document.querySelector('header');
		const margin = 15;
		let offset = margin + 30;
		if (header) offset += header.clientHeight;

		smoothScrollTo('root', this.$el, 300, {
			offsetStart: offset,
			offsetEnd: margin,
			relativeTo: 'view',
			force: true
		});
	}

	setContentHeight = () => {
		setTimeout(() => {
			if (!this.$content) return;
			const result = [...this.$content.children].reduce((prev, curr) => (prev + curr.offsetHeight), 0);
			this.setState({ contentHeight: result });
		}, 0);
	}

	keyDown(e) {
		if (e.key === 'Enter' && !this.state.disable) {
			this.select();
		}
	}


	///////////////////////
	//// CLICK HANDLERS ///
	///////////////////////

	openMap(event) {
		if (this.props.client.deviceSize === 'mobile' && this.props.addressClickOpensMap) {
			event.stopPropagation();
			Store.emit(actions.SET_MAP_OPEN, true);
			track({ a: 'open_map' });
		}
	}

	select() {
		const { theater, ticketing } = this.props;

		const isMACCS = theater.screenings.some(screening => screening.provider_id === 'maccs') ;
		if(isMACCS) {
			Store.emit(actions.SELECT_MACCS_THEATER, theater.id);
		}

		const ticketingEnabled = isTicketingEnabled(theater, ticketing);
		if (!ticketingEnabled) {
			// Don't trigger the scroll function (user clicked on it, no need)
			this.active = !this.active;
			Store.emit(actions.SELECT_THEATER, theater.id, 'list', theater);
		}
	}

	closeTicketing(event) {
		event.stopPropagation(); // Otherwise it will close the theater as well
		Store.emit(actions.CLOSE_TICKETING);
	}

	trackCustomContent(e) {
		const target = e.target;
		const type = target.getAttribute('data-linktype');
		if (!type || target.tagName.toLowerCase() !== 'a') return;
		track({ a: 'custom_content_link_' + type });
	}

	getOffer() {
		let offers = this.props.pageData.theaterOffers;
		if (!offers) {
			return;
		}
		let theater = this.props.theater;
		return sortObjectByOrder(offers).find(offer => {
			if (!offer || !offer.offer) return false;
			return Object.keys(offer).every(key => {
				let val = offer[key];
				if (key === 'exhibitor') {
					let domain = theater.exhibitor && theater.exhibitor.domain;
					if (!domain) return false;
					if (val.split(',').map(e => e.trim()).indexOf(domain) === -1) {
						return false;
					}
				}
				if (key === 'theater') {
					let id = theater.id;
					let pid = theater.pid;
					let list = val.split(',').map(e => e.trim());
					if (list.indexOf(id) === -1 && list.indexOf(pid) === -1) {
						return false;
					}
				}
				return true;
			});
		});
	}

	///////////////////////
	//// RENDER METHODS ///
	///////////////////////

	getContentOutside() {
		let full = [];
		let offer = this.getOffer();
		if (offer) {
			full.push(<div class={s.offer}>{offer.offer}</div>);
		}
		return full;
	}

	renderCustomContent() {
		// Used to be used for custom content from the theater (could be enabled through pageData.showTheaterMessaging)
		// We disabled it again because the autolinker library was massive
		// you can see the full function here: https://github.com/POWSTER/thundr/blob/0640ead819d54c2a2642e9cdd9847180f2eac668/static/src/components/shared/theaters/theater.js
		// Better to create an override to add in the extraContent instead of doing it this way
		// return;
	}

	renderLogo() {
		let props = this.props;
		let state = this.state;
		let theater = props.theater;
		let appData = props.appData;

		// ------------------------------------
		// NOTE: To use customLogo, there must be a file called 'custom-theater_icon.png' in $imageRoot
		const logoClass = props.customLogo ? s.customLogo : s.logo;
		const logoStyle = {};
		if (props.customLogo && typeof props.customLogo === 'string') {
			let url = props.customLogo;
			if (!url.match(/^(https?:)?\/\//)) {
				url = appData.urls.roots.image + '/' + url;
			}
			logoStyle.backgroundImage = 'url(' + url + ')';
		}

		let logo = accessNested(theater, 'exhibitor.logo');
		let finalImage = logo || 'default.png';
		let styling = (appData && appData.styling) || {};
		let shade = (!state.open && styling.inactiveTheaterLogoShade) || styling.logoShade || 'light';
		let logoRoot = accessNested(appData, 'urls.roots.sharedImages', '') + '/logos/' + shade + '/';

		return (
			<div class={logoClass} style={logoStyle}>
				<LogoImage
					class={logo ? s.logoImage : s.logoDefaultImage}
					src={logoRoot + finalImage}
					alt="logo"
				/>
			</div>
		);
	}

	render(props, state) {
		const {
			client, // object
			isIOS, // boolean
			theater, // object
			filters, // object
			selectedDate, // boolean
			selectedProvider, // boolean
			appData, // object
			pageData, // object
			ticketing = {} // object
		} = props;

		const {
			open,
			removing,
			disable,
			contentHeight
		} = state;

		const { copy } = appData;

		// Ticketing
		const ticketingEnabled = isTicketingEnabled(theater, ticketing);

		let theaterClass = disable ? s.disable : (open ? s.active : s.theater);

		if (ticketingEnabled) {
			theaterClass = s.ticketingTheater;
		}

		const distanceUnit = theater.distanceUnit || 'km';

		let provider;
		if (selectedProvider && theater.providers.indexOf(selectedProvider) !== -1) {
			provider = selectedProvider;
		} else {
			provider = theater.providers[0];
		}

		const homeEnt = appData.pages.showtimes.data.enableHomeEnt;

		let content = null;
		if (ticketingEnabled) {
			content = (
				<Ticketing
					key="ticketing"
					theater={theater}
					ticketing={ticketing}
					appData={appData}
					client={client}
				/>
			);
		} else if (open || removing) {
			content = (
				<Screenings
					key="screenings"
					copy={copy}
					device={client.device}
					isIOS={isIOS || client.isIOS}
					class={s.screenings}
					screenings={theater.filteredScreenings}
					providers={theater.providers}
					selectedProvider={provider}
					active={open}
					theater={theater}
					selectedDate={selectedDate}
					filters={filters}
					appData={appData}
					pageData={pageData}
					setContentHeight={this.setContentHeight}
				/>
			);
		}

		return (
			<li
				id={props.id || theater.id}
				class={theaterClass + ' theaterTheater'}
				key={theater.id}
				ref={ref => this.$el = ref}
			>
				<div
					class={joinClasses('theaterHead', s.header)}
					onClick={!disable ? this.select : null}
					onKeyDown={this.keyDown}
					ref={$ref => this.$header = $ref}
					tabindex={open || disable ? -1 : 0}
				>
					{this.renderLogo()}
					<div class={joinClasses('theaterInfo', s.theaterInfo)}>
						<h3 class={s.theaterName}>{theater.name}</h3>
						<p onClick={open && this.openMap} class={s.theaterAddress}>{theater.location.fullAddress}</p>
						{!ticketingEnabled && ( // Show distance when ticketing isnt enabled
							<span class={s.distance}>
								{theater.distance.toFixed(1) + distanceUnit}
							</span>
						)}
						{ticketingEnabled && // Show close btn when ticketing is enabled
							<div
								class={s.closeTicketingBtn}
								onClick={this.closeTicketing}
							/>
						}
					</div>
					{/* {favoritesElem} */}
				</div>
				<div
					ref={ref => this.$content = ref}
					class={s.content}
					style={open && { maxHeight: contentHeight }}
				>
					{content}
					{homeEnt && !ticketingEnabled && <HomeEnt appData={appData} key="homeent" />}
					{this.renderCustomContent()}
					<div class={s.contentOutside}>{this.getContentOutside()}</div>
				</div>
			</li>
		);
	}
}

// Prevent image flashing ? Dunno just trying things
class LogoImage extends Component {

	constructor(props) {
		super(props);
		this.state = { loaded: false };
	}

	componentWillMount() {
		this.loadNew(this.props.src);
	}

	componentWillUpdate(props) {
		if (this.props.src !== props.src) this.loadNew(props.src);
	}

	loadNew(url) {
		this.setState({ loaded: false });
		const img = new Image();
		img.onload = () => this.setState({ loaded: true });
		img.src = url;
	}

	render(props) {
		if (!this.state.loaded) return <span {...props} />;
		return <img {...props} />;
	}

}
